<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Group By" >
                                            <select class="form-control" size="large" v-model="inputGroupBy" :disabled="true">
                                                <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                </div>
        
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="From"><br>
                                            <!-- <a-range-picker v-if="inputGroupBy == 'by_hour'" v-model="inputDate" :showTime="{ format: 'hh A', use12Hours:true }" format="MM-DD-YYYY hh A" :placeholder="['Start Date', 'End Date']" :disabled-date="disabledDate" style="width:100%" /> -->
                                            <a-range-picker v-model="inputDate" :placeholder="['Start Date', 'End Date']" format="MM-DD-YYYY" :disabled-date="disabledDate" style="width:100%"/>
                                        </base-input>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Site">
                                        <!-- :disabled="site_type != 'ho'" -->
                                            <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                                <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
                                
                                <!-- <base-checkbox class="mb-3" v-model="isSeparateSite">
                                    Separate per site
                                </base-checkbox> -->
                                
                            </div>
                            <div class="col-md-4 align-self-center">
                                <div v-if="reportDescription != ''" class="card">
                                    <div class="card-body">
                                        <div class="card-text">
                                            {{ reportDescription }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
    
                                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')" type="xlsx" class="float-right"  style=" width: 20%;">
                                    <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                                </download-excel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
    </template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import reportUtils from '../../components/reportUtils'
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import VueJsonToCsv from 'vue-json-to-csv';
        import * as ExcelJS from "exceljs";
        import { saveAs } from "file-saver";
        import { getReportDescription } from '../../utilities';
        import {
            mapState,
            mapActions
        } from 'vuex'
    
        var component_x;
    
        export default {
            components: {
                VueJsonToCsv
            },
            data() {
                return {
                    spinning: false,
                    inputDate: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
                    inputGroupBy: 'by_day',
                    groupOptions: [
                        {key: 'by_day', value: 'By Day'},
                    ],
                    inputSite: [],
                    site_type: "ho",
                    siteOptions: [],
                    headerExcelInfo: "",
                    profitReports: [],
                    // locationPath: [],
    
                    currDate: moment().format("L_LT").split(":").join(";"),
                    isSeparateSite: false,
                    inputFrom: moment().startOf('month'),
                    inputTo: moment().endOf('month'),
                    monthFormat: 'MM/YYYY',
                    params: {},    
                    inputShowTop: 0,
                    JsonData: [],
                    accessRights:[],
                    accessCostPriceRights:[],
                    reportDescription: ''
                }
            },
            mounted: async function () {
                component_x = this;
    
                var userId = secureStorage.getItem("userId")
                var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?mode=all", null);
                component_x.siteOptions = sites;
                component_x.sort(component_x.siteOptions);
    
                let siteId = secureStorage.getItem("defaultSiteId")
                // this.inputSite = [sites[0].id]
                this.reportDescription = await getReportDescription(this.currentProfile)
                let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
                if(site != undefined){
                    this.site_type = site.site_type
                }
                this.accessRights = this.$attrs.access_rights || []
                this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
            },
            watch: {
                // inputSite: function(val){
                //     console.log("awas",val,this.siteOptions.map(x => x.id))
                //     if(val != null && val != [] && val != '[]' && val.length > 0){
                //         this.inputSite = val;
                //         console.log('yaw')
                //     }else{
                //         this.inputSite = this.siteOptions.map(x => x.id)
                //         console.log('yew')

                //     }

                // }
            },
            computed: {
                ...mapState(['currentProfile', 'endPoint']),
            },
            methods: {
                moment,
              
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                // Advanced Info
                disabledDate(current) {
                    return current > moment().startOf("day");
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                changeParams(params, actualParams, mode){
                    this.params = params
                    this.advancedFilterParams = actualParams
    
                    if(mode == 'filter'){
                        this.advanceFilter(false);
                    }
                },
                generateReport: async function () {
                    this.spinning = true;
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    // console.log(filter_header,additional_params,status_header, this.inputSite, this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name))
                    let filter_header = ''

                    if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != []){
                         let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                         filter_header = filter_header.concat("Sites: ", sites )
                    }else{
                        let sites = this.siteOptions.map(x => x.name)
                        filter_header = filter_header.concat("Sites: All Sites")
                    }

                    let parameters = {
                        "site_id": this.inputSite.toString(),
                        "date_from": from_date,
                        "date_to": to_date,
                        "group": this.inputGroupBy,
                        "order": this.inputSortBy,
                        "by": this.showSortInfo,
                        "isSeparate": this.isSeparateSite
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'profit_reports?', parameters);
                                  
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        return
                    }
                    var siteSpecific = get_request;
                
                    let design_x = 0
                    let design_y = 0

                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = " " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }

                    let dateOrHour = 'Date'
                    if(this.inputGroupBy == 'by_hour'){
                        dateOrHour = 'Hour'
                    } 

                    if(siteSpecific.length > 0){
                        var doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'legal' });

                        let reportLogo = document.getElementById('reportLogo');
                        doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                        let headers = [];
                        headers = [
                            [
                                {content: dateOrHour, styles: {halign: 'center', valign: 'center'}},
                                {content: 'Sales', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Cost', styles: {halign: 'center', valign: 'center'}},
                                {content: 'Profit', styles: {halign: 'center', valign: 'center'}},
                            ]
                        ]

                        let grand_sales = 0
                        let grand_cost = 0
                        let grand_profit = 0
                        for(let x=0; x < siteSpecific.length; x++){
                            this.profitReports = siteSpecific[x].report_details

                            if(x > 0 && this.profitReports.length > 0){
                                doc.addPage();
                            }

                            let reportData = [];

                            if(this.profitReports.length > 0){

                                for(let i=0; i < this.profitReports.length; i++){
                                    let reportLine = this.profitReports[i]
                                    // let basketSize = this.convertToCurrency(Number(reportLine.sales/reportLine.transaction_count))

                                    let detail = []
                                    detail = [
                                            reportLine.date_or_hour,
                                            this.convertToCurrency(Number(reportLine.sales)),
                                            this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost)), 'Z'),
                                            this.convertToCurrency(Number(reportLine.profit))
                                    ]

                                    grand_cost += Number(reportLine.cost)
                                    grand_sales += Number(reportLine.sales)
                                    grand_profit += Number(reportLine.profit)

                                    reportData.push(Object.assign({}, detail))

                                }
                            }


                            design_x = 200
                            design_y = 330
                            
                            if(x == siteSpecific.length - 1){
                                reportData.push(Object.assign({}, ["rowLine"]))

                                let grand_detail = [
                                    'Total',
                                    this.convertToCurrency(grand_sales),
                                    this.addMaskValidation(this.convertToCurrency(grand_cost), 'Z'),
                                    this.convertToCurrency(grand_profit)
                                ]
                                reportData.push(Object.assign({}, grand_detail))
                            }

                            doc.setFontSize(14);
                            doc.setFontType("bold");
                            doc.text(15,20,"Profit Report" + group_text)
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                            let splitTitle = doc.splitTextToSize("Filtered by: " + filter_header, 180);
                            doc.text(15,30,splitTitle);

                            let colStyles = {}

                            colStyles = {
                                0: {cellWidth: 'auto',halign: 'left'},
                                1: {cellWidth: 'auto'},
                                2: {cellWidth: 'auto'},
                                3: {cellWidth: 'auto'}
                            }


                            doc.autoTable({
                                startY: 45,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                tableWidth: 'auto',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 2
                                },
                                margin: { bottom: 30 },
                                styles: {
                                    cellPadding: 1.3, fontSize: 10,
                                    halign: 'right',
                                },
                                columnStyles: colStyles,
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[0] == 'Grand Total :' || data.row.raw[3] == 'Grand Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });


                        }
                        // end loop

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();
                        
                        for(let i = 1; i <= pageCount; i++) {
                            doc.setPage(i);
                            reportUtils.pdfTools.addFooter(doc, printed_by, "Profit Report" + group_text, design_x, design_y, i, pageCount)
                        }
                        // await window.open(URL.createObjectURL(doc.output("blob")))
                        doc.save(`Profit_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                    }
                    this.spinning = false;
                },
                getBase64Image(url) {
                    const img = new Image();
                    img.setAttribute('crossOrigin', 'anonymous');
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        const dataURL = canvas.toDataURL("image/png");
                        console.log(dataURL)
                    }
                    return img.src = url
                },
                async generateExcel(){
                    const workbook = new ExcelJS.Workbook();
                    workbook.created = new Date();
                    workbook.modified = new Date();
                    const sheet = workbook.addWorksheet("Profit Report", {
                        pageSetup:{paperSize: 9}
                    });
    
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    let filter_header = ''

                    if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != []){
                        let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                        filter_header = filter_header.concat("Sites: ", sites )
                    }else{
                        let sites = this.siteOptions.map(x => x.name)
                        filter_header = filter_header.concat("Sites: All Sites")
                    }

                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = " " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }

                    const data_starts_at_row = 8
    
                    let reportLogo = document.getElementById('reportLogo');
                
                    const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)
    
                    const imageId2 = workbook.addImage({
                        base64: base64Image,
                        extension: 'png',
                    });
    
                    sheet.addImage(imageId2, {
                        tl: { col: 0, row: 0 },
                        ext: { width: 61, height: 61 }
                    });
    
                    sheet.getRow(4).values = [`Profit Report ${group_text}`]
                    sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
                    sheet.getRow(6).values = [`Filtered by: ${filter_header}}`]
                    
                    let dateOrHour = 'Date'
                    if(this.inputGroupBy == 'by_hour'){
                        dateOrHour = 'Hour'
                    } 
    
                    //custom header
                    sheet.getRow(data_starts_at_row).values = [dateOrHour, "Sales", 
                        "Cost", "Profit"];

                    sheet.columns = [
                        { key: "date_or_hour" , width: 20 },
                        { key: "sales", width: 15 },
                        { key: "cost" , width: 20 },
                        { key: "profit", width: 15 }
                    ];
    
                    var report_details = this.JsonData
                    // var report_details = get_request[0].report_details
                    // console.log("details", report_details)
                    // console.log(this.JsonData)
                    var rowDatas = []
                    var horizontal_range = 0

                    for(let i = 0; i < report_details.length; i++){
                        const report_detail = report_details[i]
                            if(report_detail){
                                const rowData = {date_or_hour: report_detail[dateOrHour], sales: report_detail["Sales"], cost: report_detail["Cost"], 
                                profit: report_detail["Profit"]}
                                rowDatas.push(rowData)
                            }
                        }
    
                    sheet.addRows(rowDatas);
    
                    //styles
                    sheet.getRow(4).font = { bold: true, size: 16 };
                    sheet.getRow(4).height = 20;
                    // sheet.getRow(7).font = { bold: true };
                    sheet.getRow(data_starts_at_row).font = { bold: true };
    
                    // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                    //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                    // })
    
                    sheet.eachRow(function (Row, rowNum) {
                        if(rowNum >= data_starts_at_row){
                            Row.eachCell(function (Cell, cellNum) {
                                if (rowNum == data_starts_at_row) {
                                    Cell.alignment = {
                                        horizontal: 'center'
                                    }
                                }
                                else{
                                    Cell.alignment = {
                                        vertical: 'middle',
                                        horizontal: 'left'
                                    }
                                }
                            })
                        }
                    })
                    
                    workbook.xlsx.writeBuffer().then(function(buffer) {
                        const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                        saveAs(blob, `ProfitReport.xlsx`);
                    });
                    this.JsonData = []
                },
                generateFile: async function() {
                    this.spinning = true;
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    // let {filter_header, additional_params, status_header} = reportUtils.advanceFilterTools.buildAdditionalParams(this.params,this.advancedFilterParams, this.inputLocation)
                    let filter_header = ''

                    if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != []){
                        let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                        filter_header = filter_header.concat("Sites: ", sites )
                    }else{
                        let sites = this.siteOptions.map(x => x.name)
                        filter_header = filter_header.concat("Sites: All Sites")
                    }

                    let group_text = ""
                    if(this.inputGroupBy != ''){
                        group_text = " " + this.groupOptions.find(x => x.key === this.inputGroupBy).value
                    }


                    let parameters = {
                        "site_id": this.inputSite.toString(),
                        "date_from": from_date,
                        "date_to": to_date,
                        "group": this.inputGroupBy,
                        "order": this.inputSortBy,
                        "by": this.showSortInfo,
                        "isSeparate": this.isSeparateSite
                    }
    
                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'profit_reports?', parameters);

                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                        return
                    }

                    let dateOrHour = 'Date'
                    if(this.inputGroupBy == 'by_hour'){
                        dateOrHour = 'Hour'
                    } 
                    if(get_request.length > 0){
                        let siteSpecific = get_request;
                        let headers = [dateOrHour, "Sales", "Cost", "Profit"];
                        let site_specific = [];

                        let grand_sales = 0
                        let grand_cost = 0
                        let grand_profit = 0
                        for(let x=0; x < siteSpecific.length; x++){
                            this.profitReports = siteSpecific[x].report_details
    
                            let reportData = [];
                            if(x > 0){
                                // Add second set of headers
                                reportData.push(headers)
                            }
    
                            if(this.profitReports.length > 0){
                                
                                let grouper = 'start'
                                for(let i=0; i < this.profitReports.length; i++){
                                    let reportLine =this.profitReports[i]
                                    let detail = []
                                    detail = [
                                        reportLine.date_or_hour,
                                        this.convertToCurrency(Number(reportLine.sales)),
                                        this.addMaskValidation(this.convertToCurrency(Number(reportLine.cost)), 'Z'),
                                        this.convertToCurrency(Number(reportLine.profit))
                                    ]

                                    grand_cost += Number(reportLine.cost)
                                    grand_sales += Number(reportLine.sales)
                                    grand_profit += Number(reportLine.profit)

                                    reportData.push(Object.assign({}, detail))
                                }
    
                            }
    
                            // let group_text = ""
                            if(x == siteSpecific.length - 1){
                                reportData.push(Object.assign({}, ["rowLine"]))

                                let grand_detail = [
                                    'Total',
                                    this.convertToCurrency(grand_sales),
                                    this.addMaskValidation(this.convertToCurrency(grand_cost), 'Z'),
                                    this.convertToCurrency(grand_profit)
                                ]
                                reportData.push(Object.assign({}, grand_detail))
                            }
    
                            if(this.isSeparateSite == true){
                                reportData.unshift([siteSpecific[x].report_details[0].site_name]);
                            } else {
                                let site_text = ''
                                if(this.inputSite.length == 0){
                                    site_text = 'All Sites'
                                } else {
                                    let sites = this.inputSite
                                    for (var s = 0; s < sites.length; s++) {
                                        if(s == 0){
                                            site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                        } else {
                                            site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                        }
                                    }
                                }
                                reportData.unshift([site_text]);
                            }
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
    
                            reportData.push(["Profit Report" + group_text, "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])
                            reportData.push([])
    
                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;
    
                            let newJsonData=[];
    
                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                    [val]: values[i][index]
                                      }
                                  )
                                )
                              );
                              newJsonData.push(result)
                            }
    
                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                              for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                  obj[i] = '';
                                }
                              }
                            });
                            site_specific.push(newJsonData)
                        }
                        // for each site specific[] convert nested to single array
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                    }
                    this.spinning = false;
                },
                clearJsonData(){
                 this.JsonData = [];
                },
                addMaskValidation(value, rights){
                    if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                        return '***';
                    }else{
                        return value
                    }
                }
            }
        };
    </script>
    
    <style></style>
    